<script lang="ts">
	import type { PageData } from './$types';
	import { getSearchExtensionBaseUrl } from '$lib/services/searchExtension';

	export let data: PageData;

	// eslint-disable-next-line svelte/valid-prop-names-in-kit-pages
	export const { searchExtensionPathAndParams } = data;

	function getSearchExtensionUrl() {
		const searchExtensionBaseURL = getSearchExtensionBaseUrl();
		return `${searchExtensionBaseURL}/${searchExtensionPathAndParams}`;
	}
</script>

<iframe src={getSearchExtensionUrl()} title="Booking Search Extension" class="h-full w-full"></iframe>
